import { useState, useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import { engineApi } from '../api/client'
import './StopEngineButton.css'

export function StopEngineButton() {
  const [confirming, setConfirming] = useState(false)
  const [done, setDone] = useState(false)
  const stop = useMutation({
    mutationFn: () => engineApi.stop(),
    onSuccess: () => { setDone(true); setConfirming(false) },
  })

  useEffect(() => {
    if (!confirming) return
    // Capture phase + preventDefault so a ModuleDrawer underneath (bubble
    // phase, ignores defaultPrevented) does not also close on this Escape.
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return
      e.preventDefault()
      setConfirming(false)
    }
    window.addEventListener('keydown', onKeyDown, true)
    return () => window.removeEventListener('keydown', onKeyDown, true)
  }, [confirming])

  return (
    <div className="stop-engine">
      <button className="stop-engine-btn" onClick={() => setConfirming(true)}
              disabled={done || stop.isPending}>
        {done ? 'ENGINE STOPPED' : 'STOP ENGINE'}
      </button>
      {confirming && (
        <div className="stop-engine-modal-backdrop" role="dialog" aria-modal="true"
             aria-labelledby="stop-engine-title"
             onClick={() => setConfirming(false)}>
          <div className="stop-engine-modal" onClick={(e) => e.stopPropagation()}>
            <h3 id="stop-engine-title">Stop the trading engine?</h3>
            <p>This halts autonomous trading immediately. Confirm only on extreme failure.</p>
            <div className="stop-engine-actions">
              <button className="stop-engine-cancel" autoFocus
                      onClick={() => setConfirming(false)}>Cancel</button>
              <button className="stop-engine-confirm"
                      onClick={() => stop.mutate()}
                      disabled={stop.isPending}>
                {stop.isPending ? 'Stopping…' : 'Confirm STOP'}
              </button>
            </div>
            {stop.isError && <p className="stop-engine-err">Stop failed — retry.</p>}
          </div>
        </div>
      )}
    </div>
  )
}
